import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { filter, switchMap } from 'rxjs';
import { createGarantieCalculatorForm, GarantieCalculatorFormModel } from '../../factories/garantie-calculator-form.factory';
import { GarantieService } from '../../services/garantie.service';

@Component({
  selector: 'app-garantie-calculator',
  standalone: true,
  imports: [
    CurrencyPipe,
    PaginatorModule,
    ReactiveFormsModule
  ],
  templateUrl: './garantie-calculator.component.html',
  styleUrl: './garantie-calculator.component.scss'
})
export class GarantieCalculatorComponent implements OnInit {
  private readonly garantieService = inject(GarantieService);

  @Output() requestOffer = new EventEmitter<{ isPremiumSchutz: boolean, premium: number }>();

  form!: FormGroup<GarantieCalculatorFormModel>;

  premium: number | null = null;

  ngOnInit() {
    this.form = createGarantieCalculatorForm();

    this.form.controls.isPremiumSchutz.valueChanges
      .pipe(
        filter(val => val !== null && val !== undefined),
        switchMap(val => this.garantieService.getPremium(val))
      )
      .subscribe(premium => {
        this.premium = premium;
      });
  }

  submit(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid || this.premium === null) {
      return;
    }

    this.requestOffer.emit({
      isPremiumSchutz: this.form.getRawValue().isPremiumSchutz!,
      premium: this.premium
    });
  }
}
